var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29825 8.5L0.249242 1.45269C0.170223 1.37367 0.107541 1.27986 0.064776 1.17662C0.022011 1.07337 8.32606e-10 0.962717 0 0.850966C-8.32606e-10 0.739216 0.022011 0.62856 0.064776 0.525316C0.107541 0.422072 0.170223 0.328262 0.249242 0.249242C0.328262 0.170223 0.422072 0.107541 0.525316 0.064776C0.62856 0.022011 0.739216 -8.32606e-10 0.850966 0C0.962717 8.32606e-10 1.07337 0.022011 1.17662 0.064776C1.27986 0.107541 1.37367 0.170223 1.45269 0.249242L8.5 7.29825L15.5473 0.249242C15.7069 0.0896549 15.9233 0 16.149 0C16.3747 0 16.5912 0.0896549 16.7508 0.249242C16.9103 0.408829 17 0.625276 17 0.850966C17 1.07666 16.9103 1.2931 16.7508 1.45269L9.70175 8.5L16.7508 15.5473C16.9103 15.7069 17 15.9233 17 16.149C17 16.3747 16.9103 16.5912 16.7508 16.7508C16.5912 16.9103 16.3747 17 16.149 17C15.9233 17 15.7069 16.9103 15.5473 16.7508L8.5 9.70175L1.45269 16.7508C1.2931 16.9103 1.07666 17 0.850966 17C0.625276 17 0.408829 16.9103 0.249242 16.7508C0.0896549 16.5912 0 16.3747 0 16.149C0 15.9233 0.0896549 15.7069 0.249242 15.5473L7.29825 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.bafee09ac7d218d76dcf345352b6ef28.svg";
export { ForwardRef as ReactComponent };